import React, { useEffect, useRef } from 'react'
import {
  destroySelect2InContainer,
  initSelect2InContainer,
  syncSelect2InContainer,
} from './select2Modal'

/**
 * Одиночный select + Select2 без пустого «----» из ядра AttrInput.
 * Паттерн как js-select2-modal / js-select2-report в конфигурации СИГУР.
 */
export function SigurChoiceSelect({
  name,
  value,
  items = [],
  disabled = false,
  allowEmpty = false,
  emptyLabel = '',
  onChange,
  className = 'form-select form-select-sm js-select2-sigur',
}) {
  const wrapRef = useRef(null)
  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  useEffect(() => {
    const el = wrapRef.current
    if (!el || disabled) return undefined
    const handleChange = (fieldName, fieldValue) => {
      if (fieldName === name && onChangeRef.current) {
        onChangeRef.current(fieldValue)
      }
    }
    initSelect2InContainer(el, handleChange)
    return () => destroySelect2InContainer(el)
  }, [disabled, name, items])

  useEffect(() => {
    if (!wrapRef.current || disabled) return
    syncSelect2InContainer(wrapRef.current)
  }, [value, items, disabled])

  if (disabled) {
    const label = items.find(([v]) => String(v) === String(value))?.[1] || value || '—'
    return <span className="text-muted">{label}</span>
  }

  return (
    <div ref={wrapRef}>
      <select name={name} className={className} value={value || ''}>
        {allowEmpty && <option value="">{emptyLabel}</option>}
        {items.map(([val, label]) => (
          <option key={String(val)} value={val}>
            {label}
          </option>
        ))}
      </select>
    </div>
  )
}
